import SgCaptcha from '../../components/SgCaptcha'

export default {

    beforeDestroy() {
        this.$eventBus.$emit("dialog:close")
        this.$eventBus.$emit('loader:hide')
    },


    methods: {

        showAlreadyUseWarn() {
            this.$eventBus.$emit('modal:dialog', {
                dialogProps: {
                    noClickAnimation: true,
                    persistent: true,
                },
                props: {
                    message: "Введеный адрес электронной почты уже используется Вами.",
                    acceptText: 'Ок',
                }
            })
        },

        askIgnore(email, callback) {


            this.$eventBus.$emit('modal:dialog', {
                /*       bottom: true, */
                props: {
                    vertical: true,
                    message: "Указанный адрес электоронной почты уже используется на другой карте. В случае продолжения адрес будет отвязн от старой карты и привязан к текущей.",

                    acceptText: 'Ввести другой адрес',
                    rejectText: 'Продолжить',
                },
                listeners: {
                    /*                     accept: () => {
                                            this.$nextTick(() => {
                                                this.$refs.email.focus()
                                            })

                                        }, */
                    reject: () => {

                        this.changeEmail(email, '', true, callback)
                    }
                }




            })
        },


        showCaptcha(email, captcha, force, callback) {

            this.$eventBus.$emit('modal:open', {
                component: SgCaptcha,
                /*        bottom: true, */
                hashMode: true,
                props: {
                    captchaImage: captcha
                },
                dialogProps: {
                    fullscreen: true,
                    noClickAnimation: true,
                    persistent: true,
                    transition: "slide-x-reverse-transition"
                },
                listeners: {
                    solve: answer => {
                        this.$eventBus.$emit('modal:close')
                        this.changeEmail(email, answer, force, callback)
                    }
                }
            })
        },



        changeEmail(email, captcha, force, callback) {

            /*     if (!this.validate()) return */

            if (!email) {
                console.error('changeEmail email undefined')
            }

            this.$eventBus.$emit('loader:show', {
                overlay: true
            })

            captcha = captcha || ''

            force = (force === true)

            /*     resend = (resend === true) */

            return this.$api.emailChange(email, captcha, force)
                .then(res => {


                    if (res.status == 0) {

                        if (callback != null) {
                            callback()
                        }


                    } else {
                        switch (res.status) {
                            case 1: {
                                this.showCaptcha(email, res.captcha, force, callback)
                                break;
                            }
                            case 2: {
                                this.askIgnore(email, callback)
                                break;
                            }
                            case 3: {
                                this.showAlreadyUseWarn()
                                break;
                            }
                        }
                    }



                    return false
                })
                .catch(error => {
                    this.$eventBus.$emit('error', error)
                })
                .finally(() => {
                    this.$eventBus.$emit('loader:hide')
                })
        },
    }
}